import { Key, useState, useRef } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { UserTypeEnum } from "@/types/FmsEnums";
import { message } from 'antd';
import { ICustomerAccountSummary } from "@/views/account/AccountTypes";
import { useGlobalModel } from "@/model/globalModel";
import { accountService } from "@/views/account/AccountService";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { InvoiceBill, InvoiceIdentify } from "@/views/invoice/manage/InvoiceManageTypes";

export enum ActionTypeEnum {
    BILLING_LIST,
    BILLED_LIST,
    NO_BILL_LIST,
    NULL
}

export const useDetailModel = createModel(function () {
    const { user, user: { shopCode }, setLoadingInfo } = useGlobalModel();
    const [actionType, setActionType] = useSessionStorageState<ActionTypeEnum>("invoice.detail.type", ActionTypeEnum.NULL) // 选中展示模块

    const [customerCode, setCustomerCode] = useSessionStorageState<string>("invoice.detail.customerCode", "");
    const [customer, setCustomer] = useSessionStorageState<ICustomerAccountSummary>("invoice.detail.customer", { key: "" });

    //无票收入
    const [nobillVisible, setNobillVisible] = useState(false);

    //维护已识别的发票号码
    const [invoiceNums, setInvoiceNums] = useSessionStorageState<string[]>("invoice.invoiceNums", []);
    const invoiceNumsRef = useRef(invoiceNums);
    invoiceNumsRef.current = invoiceNums;

    //选中行用于发票匹配数据
    const [selectedDataMate, setSelectedDataMate] = useSessionStorageState<InvoiceBill[]>("invoice.mate", []);

    const customerInfo = (code?: Key) => {
        if (customerCode) {
            accountService.customerSummaryOne(customerCode, shopCode)
                .then(({ retData }) => {
                    setCustomer(retData ?? {});
                });
        }
    }

    const identification = async (md5List: string[], first: boolean, callBack: () => void) => {
        setLoadingInfo({ loadingVisible: true, txt: '发票上传中,请稍等...' });
        if (first) {
            setInvoiceNums([]);
        }
        let list: InvoiceIdentify[] = [];
        for (let i = 0; i < md5List.length; i++) {
            let url = md5List[i];
            let result = await invoiceManageService.invoiceIdentification(url);
            if (result.retCode == '200') {
                let info = result.retData.words_result[0].result;

                let InvoiceType = info.InvoiceType[0].word;
                let invoiceTypeCode = 'invoice-type.no';
                let invoiceTypeName = '无票';
                if (InvoiceType == '普通发票') {
                    invoiceTypeCode = 'invoice-type.vat-ordinary';
                    invoiceTypeName = '增值税普通发票';
                }
                else if (InvoiceType == '专用发票') {
                    invoiceTypeCode = 'invoice-type.vat-special';
                    invoiceTypeName = '增值税专用发票';
                }

                let identify: InvoiceIdentify = {
                    id: '',
                    invoiceNum: info.InvoiceNum[0].word,
                    invoiceName: info.InvoiceTypeOrg[0].word,
                    invoiceTypeCode: invoiceTypeCode,
                    invoiceTypeName: invoiceTypeName,
                    md5: url,
                    fileName: url,
                    partnerCode: customerCode,
                    partnerName: customer.name ?? '',
                    partnerTypeCode: UserTypeEnum.CUSTOMER,
                    purchaserRegisterNum: info.PurchaserRegisterNum[0].word,
                    purchaserAddress: info.PurchaserAddress[0].word,
                    purchaserBank: info.PurchaserBank[0].word,
                    purchaserName: info.PurchaserName[0].word,
                    sellerRegisterNum: info.SellerRegisterNum[0].word,
                    sellerAddress: info.SellerAddress[0].word,
                    sellerBank: info.SellerBank[0].word,
                    sellerName: info.SellerName[0].word,
                    amount: info.AmountInFiguers[0].word,
                    invoiceDate: info.InvoiceDate[0].word.replace('年', '-').replace('月', '-').replace('日', '')
                };
                list.push(identify);
                //message.error("发票识别:" + JSON.stringify(identify));
            }
            else {
                message.error("发票识别出错:" + result.retMsg)
            }
        }

        try {
            if (list.length > 0) {
                let newList = invoiceNumsRef.current.concat(list.map(e => e.invoiceNum));
                newList = Array.from(new Set(newList));
                setInvoiceNums(newList);
                let flag = await invoiceManageService.invoiceUploadInsert(list);
                callBack();
            }
        }
        catch (e) {
            console.log("系统错误" + e);
        }
        finally {
            setLoadingInfo({ loadingVisible: false, txt: '' });
        }
    }

    return {
        user,
        actionType, setActionType,
        customer, customerCode, setCustomerCode, customerInfo,
        nobillVisible, setNobillVisible,
        selectedDataMate, setSelectedDataMate,
        setInvoiceNums, invoiceNumsRef,
        identification
    }
});
